module.exports = __webpack_public_path__ + "static/media/dwarkesh.5bb6450d.png";